import React, { useEffect, useState } from "react";
import Modal from "./Modal";
import axiosInstance from "../utils/api";
import { toast } from "react-hot-toast";

const emptyForm = {
  exhibitorName: "",
  standNumber: "",
  hall: "",
  size: "",
  tentNumber: "",
  email: "",
};

const inputCls =
  "w-full px-4 py-3 bg-white border border-slate-200 rounded-xl text-slate-900 placeholder-slate-400 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all";

const StandModal = ({ isOpen, onClose, stand, eventId, onSuccess }) => {
  const [form, setForm] = useState(emptyForm);

  useEffect(() => {
    setForm(stand ? { ...emptyForm, ...stand } : emptyForm);
  }, [stand]);

  const formatPrefixedNumber = (value, prefix) => {
    if (!value) return "";

    let cleaned = value
      .replace(new RegExp(`^${prefix}`, "i"), "")
      .trim();

    cleaned = cleaned.replace(/[^\d]/g, "");

    if (!cleaned) return "";

    return `${prefix} ${cleaned}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;

    if (name === "hall") {
      setForm({ ...form, hall: formatPrefixedNumber(value, "Hall") });
      return;
    }

    if (name === "tentNumber") {
      setForm({ ...form, tentNumber: formatPrefixedNumber(value, "Tent") });
      return;
    }

    setForm({ ...form, [name]: value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      if (stand) {
        await axiosInstance.put(`/stand/${stand._id}`, form);
        toast.success("Stand updated successfully");
      } else {
        await axiosInstance.post("/stand", {
          ...form,
          event: eventId,
        });
        toast.success("Stand created successfully");
      }

      onSuccess();
      onClose();
    } catch (err) {
      console.error(err);
      toast.error(err?.response?.data?.message || "Failed to save stand");
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={stand ? "Edit Stand" : "Add Stand"}
      size="lg"
    >
      <form onSubmit={handleSubmit} className="p-6 space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Exhibitor Name *
            </label>
            <input
              name="exhibitorName"
              placeholder="Enter exhibitor name"
              value={form.exhibitorName}
              onChange={handleChange}
              className={inputCls}
              required
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Stand Number
            </label>
            <input
              name="standNumber"
              placeholder="e.g., A-101"
              value={form.standNumber}
              onChange={handleChange}
              className={inputCls}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Hall
            </label>
            <input
              name="hall"
              placeholder="e.g., Hall 6"
              value={form.hall}
              onChange={handleChange}
              className={inputCls}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Size
            </label>
            <input
              name="size"
              placeholder="e.g., 6"
              value={form.size}
              onChange={handleChange}
              className={inputCls}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Tent Number
            </label>
            <input
              name="tentNumber"
              placeholder="e.g., 6"
              value={form.tentNumber}
              onChange={handleChange}
              className={inputCls}
            />
          </div>

          <div>
            <label className="block text-sm font-medium text-slate-700 mb-2">
              Email
            </label>
            <input
              type="email"
              name="email"
              placeholder="e.g., exhibitor@company.com"
              value={form.email}
              onChange={handleChange}
              className={inputCls}
            />
          </div>
        </div>

        <div className="flex justify-end gap-3 pt-4 border-t border-slate-200">
          <button
            type="button"
            onClick={onClose}
            className="px-6 py-3 border border-slate-200 text-slate-700 rounded-xl hover:bg-slate-50 transition-all font-medium"
          >
            Cancel
          </button>
          <button
            type="submit"
            className="px-6 py-3 bg-gradient-to-r from-blue-600 to-blue-700 text-white rounded-xl hover:from-blue-700 hover:to-blue-800 transition-all shadow-lg shadow-blue-500/30 hover:shadow-blue-500/50 font-medium"
          >
            {stand ? "Update Stand" : "Create Stand"}
          </button>
        </div>
      </form>
    </Modal>
  );
};

export default StandModal;